import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { slot: "label" }

import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonSelect, IonSelectOption, IonText, IonTextarea, IonTitle, IonToolbar, modalController } from "@ionic/vue";
import { closeOutline, checkmarkDone } from "ionicons/icons";
import { translate } from '@hotwax/dxp-components';
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { generateInternalId, hasError, showToast } from "@/utils";
import logger from "@/logger";
import { ChannelService } from "@/services/ChannelService";
import emitter from "@/event-bus";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateGroupModal',
  setup(__props) {

const store = useStore();

const formData = ref({
  facilityGroupName: "",
  facilityGroupId: "",
  description: "",
}) as any;
const selectedConfigFacilityId = ref("new");
const facilityGroupId = ref("") as any;

const eComStore = computed(() => store.getters["user/getCurrentEComStore"])
const configFacilities = computed(() => store.getters["util/getConfigFacilities"])

function closeModal() {
  modalController.dismiss();
}

async function createGroup() {
  if (!formData.value.facilityGroupName?.trim()) {
    showToast(translate("Please fill in all the required fields."))
    return;
  }

  // In case the user does not lose focus from the facility name input
  // and click on create the button, we need to set the internal id manually
  if (!formData.value.facilityGroupId) {
    formData.value.facilityGroupId = generateInternalId(formData.value.facilityGroupName)
  }

  if (formData.value.facilityGroupId.length > 20) {
    showToast(translate("Internal ID cannot be more than 20 characters."))
    return
  }

  emitter.emit("presentLoader");

  let resp = {} as any;
  try {
    // Creating a new inventory channel group.
    resp = await ChannelService.createFacilityGroup({ ...formData.value, facilityGroupTypeId : "CHANNEL_FAC_GROUP" });
    if(hasError(resp)) {
      throw resp.data;
    }

    // Creating a new config facility or associating an existing one with the created group.
    let selectedConfigFacility = {} as any;
    if(selectedConfigFacilityId.value === 'new') {
      selectedConfigFacility = {
        facilityName: `${formData.value.facilityGroupName} CONFIG FACILITY`,
        facilityTypeId: "CONFIGURATION",
        parentFacilityTypeId : "VIRTUAL_FACILITY",
      }

      resp = await ChannelService.createFacility(selectedConfigFacility);
      if(!hasError(resp)) {
        selectedConfigFacility = {
          ...selectedConfigFacility,
          facilityId: resp.data.facilityId
        }

        // Associating the config facility with the product store.
        resp = await ChannelService.updateFacilityAssociationWithProductStore({productStoreId: eComStore.value.productStoreId, facilityId: selectedConfigFacility.facilityId})
        if(hasError(resp)) throw resp.data;
      } else {
        throw resp.data;
      }
    } else {
      selectedConfigFacility = configFacilities.value.find((facility: any) => facility.facilityId === selectedConfigFacilityId.value)
    }

    // Associating the facility group with the product store.
    resp = await ChannelService.updateGroupAssociationWithProductStore({productStoreId: eComStore.value.productStoreId, facilityGroupId: formData.value.facilityGroupId})
    if(hasError(resp)) throw resp.data;

    // Associating the config facility with the group.
    resp = await ChannelService.updateFacilityAssociationWithGroup({facilityGroupId: formData.value.facilityGroupId, facilityId: selectedConfigFacility.facilityId})
    if(hasError(resp)) throw resp.data;

    showToast(translate("Group has been created successfully."));
    await store.dispatch("channel/fetchInventoryChannels");
    await store.dispatch("util/fetchConfigFacilities");
    modalController.dismiss();
  } catch (error: any) {
    logger.error(error)
    showToast(error.response?.data?.errors ? error.response.data.errors : translate("Failed to create channel group."))
  }
  modalController.dismiss()
  emitter.emit("dismissLoader");
}

function setFacilityGroupId(event: any) {
  formData.value.facilityGroupId = generateInternalId(event.target.value)
}

function validateFacilityGroupId(event: any) {
  const value = event.target.value;
  facilityGroupId.value.$el.classList.remove('ion-valid');
  facilityGroupId.value.$el.classList.remove('ion-invalid');

  if (value === '') return;

  formData.value.facilityGroupId.length <= 20
    ? facilityGroupId.value.$el.classList.add('ion-valid')
    : facilityGroupId.value.$el.classList.add('ion-invalid');
}

function markFacilityGroupIdTouched() {
  facilityGroupId.value.$el.classList.add('ion-touched');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Create channel group")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonInput), {
                  labelPlacement: "floating",
                  modelValue: formData.value.facilityGroupName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.facilityGroupName) = $event)),
                  onIonBlur: _cache[2] || (_cache[2] = ($event: any) => (formData.value.facilityGroupId ? null : setFacilityGroupId($event)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_unref(translate)("Name")) + " ", 1),
                      _createVNode(_unref(IonText), { color: "danger" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("*", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonInput), {
                  label: _unref(translate)('ID'),
                  labelPlacement: "floating",
                  ref_key: "facilityGroupId",
                  ref: facilityGroupId,
                  modelValue: formData.value.facilityGroupId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.facilityGroupId) = $event)),
                  onIonInput: validateFacilityGroupId,
                  onIonBlur: markFacilityGroupIdTouched,
                  "error-text": _unref(translate)('Internal ID cannot be more than 20 characters.')
                }, null, 8, ["label", "modelValue", "error-text"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonTextarea), {
                  label: _unref(translate)('Description'),
                  modelValue: formData.value.description,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.description) = $event)),
                  labelPlacement: "floating",
                  maxlength: 255
                }, null, 8, ["label", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Product store")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonLabel), { slot: "end" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(eComStore.value.storeName ? eComStore.value.storeName : eComStore.value.productStoreId), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonSelect), {
                  label: _unref(translate)('Group level configurations'),
                  modelValue: selectedConfigFacilityId.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedConfigFacilityId).value = $event)),
                  interface: "popover"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonSelectOption), { value: "new" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Create new")), 1)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configFacilities.value, (facility) => {
                      return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                        key: facility.facilityId,
                        value: facility.facilityId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(facility.facilityName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFab), {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonFabButton), {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (createGroup()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { icon: _unref(checkmarkDone) }, null, 8, ["icon"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})